import _Promise from 'babel-runtime/core-js/promise';
import _typeof from 'babel-runtime/helpers/typeof';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
//↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓________公共数据________↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
import CryptoJS from 'crypto-js';
import EXIF from 'exif-js';

//↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓________公共方法________↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
var utils = {
	setStg: function setStg(name, obj) {
		//缓存数据
		sessionStorage.setItem(name, _JSON$stringify(obj)); //转化为JSON字符串
	},
	getStg: function getStg(name) {
		//读取数据
		try {
			return JSON.parse(sessionStorage.getItem(name)); //解析JSON字符串
		} catch (e) {
			return sessionStorage.getItem(name); //解析JSON字符串
		}
	},
	removeStg: function removeStg(name) {
		//清除缓存
		sessionStorage.removeItem(name);
	},
	responseObj2Arr: function responseObj2Arr(obj) {
		var arr = [];
		for (var i in obj) {
			var o = {};
			o.Subkey = i;
			o.name = obj[i];
			arr.push(o);
		}
		return arr;
	},
	uniqArr: function uniqArr(arr) {
		//数组去重
		var temp = {},
		    r = [],
		    len = arr.length,
		    val,
		    type;
		for (var i = 0; i < len; i++) {
			val = arr[i];
			type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
			if (!temp[val]) {
				temp[val] = [type];
				r.push(val);
			} else if (temp[val].indexOf(type) < 0) {
				temp[val].push(type);
				r.push(val);
			}
		}
		return r;
	},
	deciyption: function deciyption(data) {
		//所有页面导入数据后错误数据解密
		var _key = '65236514';
		var keyHex = CryptoJS.enc.Utf8.parse(_key);
		var result = CryptoJS.DES.decrypt({
			ciphertext: CryptoJS.enc.Base64.parse(data)
		}, keyHex, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		});
		return JSON.parse(result.toString(CryptoJS.enc.Utf8));
	},
	is_weixin: function is_weixin() {
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf("micromessenger") >= 0) {
			return true;
		} else {
			return false;
		}
	},
	nowDate: function nowDate() {
		var date = new Date();
		var seperator1 = "-";
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var strDate = date.getDate();
		if (month >= 1 && month <= 9) {
			month = "0" + month;
		}
		if (strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
		}
		var currentdate = year + seperator1 + month + seperator1 + strDate;
		return currentdate;
	},
	getQueryVariable: function getQueryVariable(variable) {
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			if (pair[0] == variable) {
				return pair[1];
			}
		}
		return false;
	},

	getOrientation: function getOrientation(file) {
		return new _Promise(function (resolve) {
			EXIF.getData(file, function () {
				var orient = EXIF.getTag(this, 'Orientation');
				resolve(orient);
			});
		});
	},

	dataURLtoFile: function dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(',');
		var mime = arr[0].match(/:(.*?);/)[1];
		var bstr = atob(arr[1]);
		var n = bstr.length;
		var u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
	},

	rotateImage: function rotateImage(image, width, height) {
		var canvas = document.createElement('canvas');
		var ctx = canvas.getContext('2d');
		ctx.save();
		canvas.width = height;
		canvas.height = width;
		ctx.rotate(90 * Math.PI / 180);
		ctx.drawImage(image, 0, -height);
		ctx.restore();
		return canvas.toDataURL("image/jpeg");
	}

};
export { utils };
//↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑


// WEBPACK FOOTER //
// ./src/assets/public.js